import { createAction } from '@reduxjs/toolkit';
import { OLDialogProps } from '../interfaces';
import { storeName } from '../config';

export const showOLDialog = createAction<OLDialogProps>(
  `${storeName}/showOLDialog`,
);
